import { useQuery } from "react-query";
import axios from "../utils/axios-util";

const fetchCustomers = () => {
  return axios({ url: "/config/workspace", method: "get" });
};

const useCustomers = () => {
  return useQuery("customers", () => fetchCustomers());
};

export default useCustomers;
